module.exports = __webpack_public_path__ + "img/level5.c27587ce.png";